import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loading } from '../Loading';
import { SIGN_IN_PATH } from '../../config/auth';
import { useAuth } from '../../providers/AuthProvider/AuthProvider';

export function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return <Loading />;
  }

  if (!auth.isAuthenticated) {
    return (
      <Navigate
        replace
        to={{
          pathname: SIGN_IN_PATH,
          search: location.search,
          hash: location.hash,
        }}
      />
    );
  }

  return <Outlet />;
}

export function PublicOnlyRoute() {
  const auth = useAuth();

  if (auth.isLoading) {
    return <Loading />;
  }

  return auth.isAuthenticated ? <Navigate replace to="/tours" /> : <Outlet />;
}
